<template>
  <div class="main-container myorder my-account-page mt30">
    <!--    <code>    {{ orders }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">
        <div class="col-md-12">
          <div class="account-summary-card animated slideInUp">
            <div class="account-summary-copy">
              <span class="account-eyebrow">My Account</span>
              <h1>Account Overview</h1>
              <p>Track your current sales commission and account activity from one clean space.</p>
            </div>
            <div class="account-commission-card">
              <div class="account-commission-icon">
                <img src="@/assets/images/up.png" alt="">
              </div>
              <div>
                <span class="account-stat-label">Sales Commission</span>
                <strong><span class="animated bounceIn">{{sales_commission}}</span> &#8364;</strong>
              </div>
            </div>
          </div>
          <div class="account-details-card">
            <h3 class="c-title">Account Details</h3>
            <div class="account-details-grid">
              <div class="form-group">
                <label>Full Name</label>
                <input type="text" class="form-control" v-model="name" readonly>
              </div>
              <div class="form-group">
                <label>Phone Number</label>
                <input type="text" class="form-control" v-model="phone" readonly>
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="text" class="form-control" v-model="email" readonly>
              </div>
              <div class="form-group">
                <label>Area</label>
                <input type="text" class="form-control" v-model="area" readonly>
              </div>
              <div class="form-group account-address-field">
                <label>Address</label>
                <textarea class="form-control" v-model="address" readonly></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 20);
      });

  });

  import axios from 'axios';

  export default {
    data() {
      return {
        token: '',
        sales_commission: 0,
        getcarts: [],
        modalProductData: [],
        recentViews: [],
        categories: [],
        carts: [],
        loadMore: true,
        isOpen: true,
        sum_cart_total: '',
        quantity: 1,
        images: [],
        parseCartData: [],
        changeModalGallery_image: '',
        fullname: '',
        deliveryAddress: '',
        order_items: [],
        name: '',
        email: '',
        finalOrderStatus: '',
        phone: '',
        country: '',
        district: '',
        area: '',
        zip: '',
        address: '',
      };
    },
    created: function () {
      this.fetchUserInfo();
      this.loadApiData();
    },
    methods: {
      fetchUserInfo: function () {
        if (!localStorage.getItem("userinfo")) {
          return;
        }
        let userInfo = JSON.parse(localStorage.getItem("userinfo"));
        this.name = userInfo.name || "";
        this.email = userInfo.email || "";
        this.phone = userInfo.phone || "";
        this.country = userInfo.country || "";
        this.district = userInfo.district || "";
        this.area = userInfo.area || "";
        this.zip = userInfo.zip || "";
        this.address = userInfo.address || "";
      },
      loadApiData: function () {
        let vm = this;
          let logged_in_user_id = localStorage.getItem('logged_in_user_id');

          axios.get(this.globalUrl+"marketer/"+logged_in_user_id)
            .then(function (response) {
              console.log(response);
              if(response.data.affiliate_commission>0){
                vm.sales_commission = response.data.affiliate_commission;
              }
            })
            .catch((response) => {
            });
        }
    }
  };
</script>
